import styled from "styled-components";
export const WidgetContainer = styled.div `
  display: block;
  height: 100%;
  width: 100%;
  padding-top: 30px;
  position: relative;
  background: white;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
  border: 1px solid #d9d9d9;
  transition: box-shadow 0.3s ease-in-out;
  .highcharts-tooltip {
    z-index: 1000 !important;
    data-z-index: 100 !important;
  }
  flex-grow: 1;
`;
export const WidgetHeader = styled.div `
  display: block;
  height: 30px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  overflow: hidden;
`;
export const WidgetHeaderName = styled.div `
  display: block;
  height: 30px;
  padding: 0 7px;
  font-size: 14px;
  line-height: 30px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  /* float: left; */
`;
export const WidgetHeaderAction = styled.button `
  display: block;
  width: 30px;
  height: 30px;
  float: right;
  color: #666666;
  text-align: center;
  cursor: pointer;
  background: none;
  border: none;
`;
export const WidgetContent = styled.div `
  display: block;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
`;
//# sourceMappingURL=data:application/json;base64,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